
const lodash = require("lodash");

export function additionalFilterOnInputForMr(inputObject){

  let dummyObject = lodash.cloneDeep(inputObject);

  // Removing entries with blank string.
  for (let key in dummyObject){
    if (key == 'marfatiya' && key != "") {
      dummyObject[key] = dummyObject[key].toUpperCase();
    }
    if (dummyObject[key] == "") {
      dummyObject[key] = null;
    } 
  }
  if (
    Array.isArray(dummyObject.bilty_nos) &&
    dummyObject.bilty_nos.length > 0 &&
    dummyObject.bilty_nos[0].consignee_id
  ) {
    dummyObject.billing_party = dummyObject.bilty_nos[0].consignee_id;
  }

  return dummyObject;

}

function parseNumericValue(value) {
  if (value === "" || value === null || value === undefined) {
    return 0;
  }
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
}

export function calculateBiltyTotal(biltyIds) {
  if (!Array.isArray(biltyIds) || biltyIds.length === 0) {
    return 0;
  }
  
  return biltyIds.reduce((total, bilty) => {
    if (bilty.pay_type_name === "To Pay") {
      if (bilty.transporter_id != null && bilty.transporter_id !== "") {
        return total + parseNumericValue(bilty.transporter_freight);
      } else {
        return total + (
          parseNumericValue(bilty.freight) +
          parseNumericValue(bilty.hamali) +
          parseNumericValue(bilty.door_del_charge) +
          parseNumericValue(bilty.bilty_charge) +
          parseNumericValue(bilty.other_amount)
        );
      }
    }
    return total;
  }, 0);
}

export function effectForUpdatingTotalAmount(pageStateDummy){
  
  let needsUpdate = false;
  let updatedPageState = {};
  
  let hamali = parseNumericValue(pageStateDummy["hamali"]);
  let service_charge = parseNumericValue(pageStateDummy["service_charge"]);
  let demarage_charge = parseNumericValue(pageStateDummy["demarage_charge"]);
  let other_charge = parseNumericValue(pageStateDummy["other_charge"]);
  let refund = parseNumericValue(pageStateDummy["refund"]);
  let total_amount = parseNumericValue(pageStateDummy["total_amount"]);
  let to_pay_amount = parseNumericValue(pageStateDummy["to_pay_amount"]);
  
  const biltyIds = pageStateDummy.bilty_ids || [];
  const isBiltyIdsEmpty = biltyIds.length === 0;
  
  if (!isBiltyIdsEmpty) {
    // Calculate total from bilty_ids
    const calculatedBiltyTotal = calculateBiltyTotal(biltyIds);
    const isBiltyTotalEqualToPayAmount = calculatedBiltyTotal === to_pay_amount;
    
    // Only update to_pay_amount if bilty's total_amount is NOT equal to current to_pay_amount
    if (!isBiltyTotalEqualToPayAmount) {
      console.log("Updating to_pay_amount from", to_pay_amount, "to", calculatedBiltyTotal);
      to_pay_amount = calculatedBiltyTotal;
      needsUpdate = true;
      updatedPageState["to_pay_amount"] = String(calculatedBiltyTotal);
    }
  } else {
    console.log("Bilty IDs is empty, skipping bilty calculation");
  }
  
  // Calculate expected total amount
  const expectedTotal = hamali + service_charge + demarage_charge + other_charge + to_pay_amount - refund;
  
  // Update total_amount if different from expected
  if (total_amount !== expectedTotal) {
    console.log("Updating total_amount from", total_amount, "to", expectedTotal);
    total_amount = expectedTotal;
    needsUpdate = true;
    updatedPageState["total_amount"] = String(total_amount);
  }
  
  return [needsUpdate, updatedPageState];
}

export function mrAutoUpdationEffectsDummy(pageStateDummy){
    let updatedPageState = {};
    let updatedPageStateTotal = {};
    let needsUpdate = false;
    let tempNeedsUpdate = false;

    [tempNeedsUpdate, updatedPageState] = effectForUpdatingTotalAmount({...pageStateDummy});
    pageStateDummy = {...pageStateDummy, ...updatedPageState}
    updatedPageStateTotal = {...updatedPageStateTotal, ...updatedPageState}
    if (tempNeedsUpdate){
        needsUpdate = true;
    }

    if (needsUpdate){
        return [needsUpdate, updatedPageStateTotal]
    }
    else{
        return [needsUpdate, {}]
    }
}
